import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { GovernyInfo } from "../../../lib/types";
import { leaveAlliance, openDialog } from "../../../store/actions";

interface IProps {
  emperor: boolean;
  last: boolean;
  marketItems: boolean;
  members?: GovernyInfo[];
  elementRef: any;
}

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  leaveAllianceDispatch: (newEmperorId: number | null) => dispatch(leaveAlliance(newEmperorId))
});

const connector = connect(null, mapDispatchToProps);

const LeaveAlliance = ({
  emperor,
  last,
  marketItems,
  members,
  elementRef,
  openDialogDispatch,
  leaveAllianceDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [newEmperorId, setNewEmperorId] = useState<number | null>(emperor
  && members && members.length ? members[0].id : null);

  const handleSelectChange = (emperorId: number) => {
    setNewEmperorId(emperorId);
  };

  return (
    <>
      <div className={"dialog-content"}>
        {emperor && !last
          ? <>
            <table className='table'>
              <tr>
                <td>
                  <strong>You are the emperor of the alliance and
                    you have to hand over the emperor before leave</strong>
                </td>
              </tr>
            </table>
            <table className='table'>
              <tr>
                <td><strong>New emperor</strong></td>
                <td>
                  <div className='dropdown'>
                    <select
                      className="input"
                      onChange={e => handleSelectChange(Number.parseInt(e.target.value, 10))}
                    >
                      {members && members.map((m, i) => <option
                        value={m.id}
                        selected={(!newEmperorId && i === 0) || m.id === newEmperorId}
                      >
                        {m.name}
                      </option>)}
                    </select>
                  </div>
                </td>
              </tr>
            </table>
          </>
          : <></>}
        {last
          ? <table className='table'>
            <tr>
              <td>
                <strong>
                  You are the last member. Your alliance will be disbanded.
                </strong>
              </td>
            </tr>
          </table> : <></>
        }
        {marketItems
          ? <table className='table'>
            <tr>
              <td>
                <strong>
                  You have resources placed on alliance market,
                  they will be returned to your governorate.
                </strong></td>
            </tr>
          </table> : <></>
        }
        <table className='table'>
          <tr>
            <td><strong>Do you want to leave the alliance?</strong></td>
          </tr>
        </table>
      </div>
      <div className={"dialog-footer"}>
        <a
          href="#"
          onClick={() => openDialogDispatch({
            name: "AllianceActions",
            header: "Leave the alliance",
            clear: true,
            elementRef
          })}
          className="btn btn-blank btn-no-width"
        >
          Back
        </a>
        <button
          onClick={() => leaveAllianceDispatch(newEmperorId)}
          className="btn btn-blank btn-no-width"
        >Leave</button>
      </div>
    </>
  )
}

export default connector(LeaveAlliance);
